import { Component, OnInit } from '@angular/core';

import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';

import { SeoService } from '../../services/seo.service';

export interface IssueRow {
  issue: string;
  lydia: string;
  stevens: string;
  elSayed: string;
  rogers: string;
  lydiaClass: 'pos' | 'neg' | 'neutral';
}

@Component({
  selector: 'app-compare',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './compare.component.html',
  styleUrls: ['./compare.component.css'],
})
export class CompareComponent implements OnInit {

  private readonly baseUrl =
    'https://www.lydialynnchristensen.com';

  private readonly comparePageId =
    `${this.baseUrl}/compare#compare`;

  constructor(private seo: SeoService) {}

  ngOnInit(): void {
    this.seo.update(
      'Compare Candidates',
      'See how Lydia Christensen compares to other Michigan 2026 Senate candidates on the Great Lakes, healthcare, LGBTQ+ rights, and more.',
      'compare'
    );

    this.seo.setStructuredData({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "@id": this.comparePageId,
      "url": `${this.baseUrl}/compare`,
      "name": "Compare Candidates",
      "description": "Comparison of Michigan 2026 Senate candidates across selected policy issues and campaign information.",
      "isPartOf": {
        "@id": this.seo.websiteId
      },
      "about": {
        "@id": this.seo.lydiaId
      },
      "publisher": {
        "@id": this.seo.campaignId
      },
      "inLanguage": "en-US"
    });
  }

  rows: IssueRow[] = [
    {
      issue: 'Great Lakes Protection',
      lydia: 'Constitutional protection, zero-compromise',
      stevens: 'Supports PFAS cleanup funding',
      elSayed: 'Clean Air & Water plank, anti-corporate',
      rogers: 'Supports sportsmen\'s rights, general conservation',
      lydiaClass: 'pos',
    },

    {
      issue: 'Party Affiliation',
      lydia: 'Libertarian - principled, not establishment',
      stevens: 'Democrat - DSCC-backed',
      elSayed: 'Democrat - Bernie-endorsed progressive',
      rogers: 'Republican - Trump-endorsed',
      lydiaClass: 'pos',
    },

    {
      issue: 'Corporate Donations',
      lydia: 'None - 100% people-funded',
      stevens: 'Accepts PAC & corporate money',
      elSayed: 'No corporate money (stated)',
      rogers: 'Accepts corporate & PAC money',
      lydiaClass: 'pos',
    },

    {
      issue: 'Cryptocurrency Policy',
      lydia: 'Dedicated platform plank, crypto donations coming soon',
      stevens: 'No stated position',
      elSayed: 'No stated position',
      rogers: 'Accepts BitPay crypto donations',
      lydiaClass: 'pos',
    },

    {
      issue: 'LGBTQ+ Rights',
      lydia: 'Full equality, co-hosting Pride events',
      stevens: 'Supports equality',
      elSayed: 'Civil Rights & Liberties plank',
      rogers: 'No dedicated LGBTQ+ platform',
      lydiaClass: 'pos',
    },

    {
      issue: 'Legislative Transparency',
      lydia: 'Built live Bill Tracker & Delegation Report Card',
      stevens: 'Accomplishments page',
      elSayed: 'Policy subpages',
      rogers: 'No tracker tool',
      lydiaClass: 'pos',
    },

    {
      issue: 'Healthcare',
      lydia: 'Medicaid expansion, affordable care for all',
      stevens: 'Protect ACA, prescription drug access',
      elSayed: 'Medicare for All',
      rogers: 'Market-based solutions',
      lydiaClass: 'pos',
    },

    {
      issue: 'UP & Rural Michigan',
      lydia: 'From Ironwood - UP is home, not a photo op',
      stevens: 'Suburban Detroit base (MI-11)',
      elSayed: 'Detroit/Wayne County base',
      rogers: 'Southwest Michigan base (St. Joseph)',
      lydiaClass: 'pos',
    },

    {
      issue: 'Ballot Access',
      lydia: 'Automatic via Libertarian Party nomination',
      stevens: 'Automatic party ballot access',
      elSayed: 'Volunteer-collected signatures (30,000)',
      rogers: 'Automatic party ballot access',
      lydiaClass: 'pos',
    },

    {
      issue: 'Events Platform',
      lydia: 'Invite-Lydia form, weekly organizing call',
      stevens: 'No dedicated events page',
      elSayed: 'Mobilize.us integration',
      rogers: 'No events platform',
      lydiaClass: 'neutral',
    },
  ];
}